import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';

import { Estate } from '@/features/estates-property/api/estate';
import { QueryConfig } from '@/lib/react-query';
import { api, extractData } from '@/lib/treaty';

export type ImagesQueryOptions = {
  queryConfig?: QueryConfig<typeof getImages>;
  id: Estate['id'];
};

export const getImages = (id: Estate['id']) => {
  return extractData(api.estates({ id }).images.get());
};

export const getImagesOptions = (id: Estate['id']) => ({
  queryKey: ['image', id],
  queryFn: () => getImages(id),
});

const getMediaQueryOptions = (id: Estate['id']) => {
  return queryOptions(getImagesOptions(id));
};

export const useImages = ({ queryConfig, id }: ImagesQueryOptions) => {
  return useSuspenseQuery({ ...queryConfig, ...getMediaQueryOptions(id) });
};
